import React from 'react';

const svgProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
  focusable: 'false',
};

/** Automated / robot — from schedule-test-launch mockup i-robot */
export function LaunchTypeAutomatedIcon({ className }) {
  return (
    <svg {...svgProps} className={className} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="8" width="18" height="12" rx="2" />
      <path d="M12 8V4M9 2h6" />
      <circle cx="8.5" cy="13.5" r="1" />
      <circle cx="15.5" cy="13.5" r="1" />
      <path d="M9.5 17h5" />
    </svg>
  );
}

/** Manual / users — from mockup i-users */
export function LaunchTypeManualIcon({ className }) {
  return (
    <svg {...svgProps} className={className} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16 5.5a3 3 0 0 1 0 5" />
      <path d="M18.5 20a5.5 5.5 0 0 0-3-4.6" />
    </svg>
  );
}

/** Complete / stack — from mockup i-stack */
export function LaunchTypeCompleteIcon({ className }) {
  return (
    <svg {...svgProps} className={className} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 3 7.5 12 12l9-4.5L12 3z" />
      <path d="M3 12.5 12 17l9-4.5" />
      <path d="M3 17 12 21.5 21 17" />
    </svg>
  );
}

/** Selected check — from mockup i-check */
export function LaunchTypeCheckIcon({ className }) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.5 2.5 4.5-5" />
    </svg>
  );
}

/** Disabled ban — from mockup i-ban */
export function LaunchTypeBanIcon({ className }) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      aria-hidden
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="m5.6 5.6 12.8 12.8" />
    </svg>
  );
}
